<template>
  <div style="width: 100%; background-color: #f7f7f7;">
    <div class="manage-title"  style="margin-bottom: 12px;">
      <div class="manage-line"></div>
      <div class="manage-text">请选择要添加的组员</div>
    </div>
    <van-checkbox-group v-model="userIds" v-for="(item, index) in list" :key="index" style="background-color: #ffffff;">
      <van-checkbox style="margin-left: 6px;" :name="item.id">
        <div class="flex-container">
          <van-image round width="50px" height="43px" :src="item.img" />
          <van-cell :label="item.account" :border="false">
            <!-- 使用 title 插槽来自定义标题 -->
            <template #title> 
              <div class="manage-tags">
                  <div>{{item.name}}</div>
              </div>
            </template>
          </van-cell>
        </div>
      </van-checkbox>
    </van-checkbox-group>
     <div class="footer">
      <van-button round type="info" @click="onUsersDepartmen">确定</van-button>
    </div>
  </div>
</template>

<script>

import request from "@/utils/request";
import { Toast } from 'vant';

export default {
   props: {
    firmId: {
      type: String,
      default: ""
    },
    departmentId: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      userIds: [],
      list: [],
    };
  },
  created() {
    this.onLoad();
  },

  methods: {
    onLoad() {
      request.get("/User/Department/GetUndistributedList", { params: { firmId: this.firmId }})
        .then((res) => {
         this.list = res.data.data
        })
        .catch(() => {});
    },
     onUsersDepartmen() {
      request.post("/User/Department/SetUsersDepartmen", {
        "userIds": this.userIds,
        "departmentId": this.departmentId
      }).then(() => {
         Toast("操作成功");
          this.$router.go(-1);
      }).catch(() => {
      });
    },
  }
};
</script>

<style lang="less">
.flex-container {
  display: flex;
  align-items: center;
  justify-content: space-between; /* 或者使用 flex-start, flex-end, center, space-around, space-evenly 等 */
}

.manage-title {
  display: flex;
  align-items: center;
  background-color: #fff;
  padding: 12px;
  width: 100%;
}

.manage-tags {
  display: flex;
  align-items: center;
}

.manage-line {
  background-color: #3a71ffff;
  border-radius: 4px;
  margin: 3px;
  width: 4px;
  height: 16px;
}

.manage-text {
  color: #333;
  margin-left: 6px;
}

.footer {
  position: fixed;
  bottom: 12px;
  right: 12px;
  width: 100%;
  text-align: right; /* 如果你想让按钮居中 */
}

</style>
